<template>
    <div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title has-text-white">Item Has No Registered Date of Purchase {{ initSerial }}</p>
                <button
                    type="button"
                    class="delete"
                    @click="$emit('close')"/>
            </header>
            <section class="modal-card-body has-background-dvodark">
            <b-field label="Select a date">
                <b-datepicker
                    v-model="warrantyDate"
                    locale="en-US"
                    placeholder="Click to select..."
                    icon="calendar-today"
                    trap-focus>
                </b-datepicker>
            </b-field>
            </section>
            <footer class="modal-card-foot">
                <b-button class="is-dvogreen" @click="submitDate()">Finish Request</b-button>
            </footer>
        </div>
    </div>
</template>

<script>
import { API } from 'aws-amplify';
import { itemHandler } from '../graphql/mutations'
export default {
    data(){
        return {
            warrantyDate: new Date()
        }
    },
    computed:{
        computedWarrantyDate: function(){
            return this.warrantyDate.toISOString().slice(0, 10)
        }
    },
    props: ['initSerial'],
    methods:{
        async submitDate(){
            console.log(this.computedWarrantyDate)
            console.log(this.initSerial)
            console.log(typeof this.initSerial)
            await API.graphql({
                query: itemHandler,
                variables: {
                input: {
                    request_type: 'update_date_purchase',
                    date_purchase: this.computedWarrantyDate,
                    serial: this.initSerial
                }}
            });
            this.$emit('close')
        }
    },
}
</script>

<style lang="scss">
</style>